<template>
  <div class="mod-mobile-result">
    <div class="mod-header">
      <h5 class="main-title">赋能企业数字化转型</h5>
      <p class="sub-title">注册员工账号</p>
    </div>
    <div class="mod-wait-img"></div>
    <h3 class="main-title">等待审核中…</h3>
    <p class="sub-text">您的申请信息已提交，请耐心等待企业审核，审核通过后，将短信通知您</p>
    <div class="button-box"><van-button plain :color="'#409eff'" @click="onReback">返回登录页</van-button></div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    onReback () {
      this.$router.push({ path: '/m-auth' })
    }
  }
}
</script>

<style lang="less">
.mod-mobile-result{
   background-color: #F6F8FB;
  min-height: 100vh;
  text-align: center;
  .mod-header{
    width: 100%;
    height: 205px;
    margin: 0 auto;
    position: relative;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('/imgs/m_header.png');
    background-color: transparent;
    .main-title{
      font-size: 24px;
      color: #FFFFFF;
      height: 33px;
      line-height: 33px;
      margin: 0 auto;
      padding-top: 40px;
      font-weight: 600;
      text-align: center;
      box-sizing: content-box;
    }
    .sub-title{
      font-size: 15px;
      color: #FFFFFF;
      height: 21px;
      line-height: 21px;
      text-align: center;
      padding-top: 8px;
    }
  }
  .mod-wait-img{
    width: 90px;
    height: 90px;
    margin:0 auto;
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url('/imgs/m_wait.png');
    background-color: transparent;
  }
  .main-title{
    margin: 15px 0;
    height: 33px;
    line-height: 33px;
    font-size: 24px;
    color: #333333;
    font-weight: 600;
    text-align: center;
  }
  .sub-text{
    color: #666;
    font-size: 14px;
    text-align: center;
    line-height: 24px;
    box-sizing: border-box;
    padding: 0 30px;
  }
  .button-box{
    width: 100%;
    box-sizing: border-box;
    padding: 40px 30px 0;
    text-align: center;
    .van-button--normal{
      width: 100%;
    }
  }
}
</style>
